// Renders admin-entered SEO copy. Understands light markdown (## / ### headings,
// **bold**, "- " bullets) plus the legacy convention where a short line ending
// in ":" (e.g. "Key Benefits:") becomes a heading, so crawlers see structure.
const HEADING_RE = /^([A-Z][A-Za-z0-9 &/'’-]{2,60}):\s*$/;
const MD_HEADING_RE = /^(#{1,4})\s+(.+?)\s*#*\s*$/;
const BULLET_RE = /^\s*[-*•]\s+(.+)$/;
const LEADING_EMOJI_RE = /^[\p{Extended_Pictographic}\p{Emoji_Presentation}\uFE0F\u200D\s]+/u;

/** Drop a first line that just repeats the product name (common in imported copy). */
export function cleanDescription(text, name) {
  const lines = String(text || "").split(/\r?\n/);
  const first = (lines[0] || "").replace(/^#+\s*/, "").trim().toLowerCase();
  if (name && first === String(name).trim().toLowerCase()) lines.shift();
  return lines.join("\n").trim();
}

function inline(text, keyBase) {
  // **bold** → <strong>
  const parts = String(text).split(/(\*\*[^*]+\*\*)/g).filter(Boolean);
  return parts.map((p, i) =>
    p.startsWith("**") && p.endsWith("**")
      ? <strong key={`${keyBase}-${i}`} className="font-semibold text-kolt-slate-dark">{p.slice(2, -2)}</strong>
      : p
  );
}

export function SeoProse({ text, testId, className = "text-sm text-slate-700" }) {
  const blocks = [];
  let para = [];
  let list = [];
  const flushPara = () => { if (para.length) blocks.push({ type: "p", text: para.join("\n") }); para = []; };
  const flushList = () => { if (list.length) blocks.push({ type: "ul", items: list }); list = []; };
  (text || "").split(/\r?\n/).forEach((line) => {
    const t = line.trim();
    const md = t.match(MD_HEADING_RE);
    const legacy = t.match(HEADING_RE);
    const bullet = t.match(BULLET_RE);
    if (md) { flushPara(); flushList(); blocks.push({ type: "h2", text: md[2].replace(/\*\*/g, "").replace(LEADING_EMOJI_RE, "") }); }
    else if (legacy) { flushPara(); flushList(); blocks.push({ type: "h2", text: legacy[1] }); }
    else if (bullet) { flushPara(); list.push(bullet[1]); }
    else if (!t) { flushPara(); flushList(); }
    else { flushList(); para.push(line); }
  });
  flushPara(); flushList();
  if (blocks.length && blocks[blocks.length - 1].type === "h2") blocks.pop(); // heading with nothing under it (FAQ follows)
  return (
    <div className={`prose prose-slate max-w-none leading-relaxed ${className}`} data-testid={testId}>
      {blocks.map((b, i) => {
        if (b.type === "h2") return <h2 key={i} className="font-display font-black text-base md:text-lg text-kolt-slate-dark mt-5 mb-2 first:mt-0">{b.text}</h2>;
        if (b.type === "ul") return (
          <ul key={i} className="my-2 pl-5 list-disc space-y-1">
            {b.items.map((it, k) => <li key={k}>{inline(it, `${i}-${k}`)}</li>)}
          </ul>
        );
        return <p key={i} className="whitespace-pre-wrap my-2">{inline(b.text, i)}</p>;
      })}
    </div>
  );
}
